import React, {Fragment, useRef, useEffect, useState } from 'react'; 
import { observer } from 'mobx-react'; 
import { CollapseMenu } from 'cd-eft/components/common/CollapseMenu'; 
import { render } from '@testing-library/react'; 
import BermSlope from '../../../../../../assets/images/BermSlope.png'; 

export const PopupContainer = (props: { title?: String }) => {
    if (props.title === undefined ) {
        return (
            <div className= 'Waterway-Input-Details' >
                <CollapseMenu
                titleClass= {'waterway-input-details-menu'} 
                noIcon= {true} 
                title= {'Info'} 
                isOpen= {true}
                >
                    <InfoDetails className= "wdt-info p-0"></InfoDetails>
                </CollapseMenu>
                <CollapseMenu
                titleClass = {'waterway-input-details-menu'} 
                noIcon= {true} 
                title= {'Hydrology'} 
                isOpen= {true} 
                >
                    <HydrologyDetails className= "wdt-hydrology p-0"></HydrologyDetails>
                </CollapseMenu>
                <CollapseMenu
                titleClass= {'waterway-input-details-menu'} 
                noIcon= {true} 
                title= {'Alignment'}
                isOpen= {true} 
                >
                    <AlignmentDetails className= "wdt-alignment p-0"></AlignmentDetails>
                </CollapseMenu>
                <CollapseMenu
                titleClass= {'waterway-input-details-menu'} 
                noIcon= {true} 
                title= {'Design Controls'}
                isOpen= {true} 
                >
                    <DesignControlsDetails className= "wdt-design-controls p-0"></DesignControlsDetails>
                </CollapseMenu>
            </div>
        ); 
    }
    return (
        <div>
            {props.title === 'Info' && <InfoDetails />} 
            {props.title === 'Hydrology' && <HydrologyDetails />} 
            {props.title === 'Alignment' && <AlignmentDetails />} 
            {props.title === 'Design Controls' && <DesignControlsDetails />}
        </div>
    ); 
}; 

export const WaterWayInputDetails = observer(PopupContainer);

export const InfoDetails = (props: { className?: string }) => {
    return (
        <div className={props.className ? props.className : ''} tabIndex={0}>
            <p>
                <strong>The Waterway Name</strong> is a required field and should have a unique name to distinguish it from any other waterways in the Project.
            </p>
            <p>
                <strong>The Waterway Benchmark </strong> fields are optional and will only be used for information on the construction checkout 
                report. The Benchmark ID, Elevation and Description should correlate to the specific Waterway being designed.
            </p>
        </div>
    ); 
}; 

export const HydrologyDetails = (props: { className?: string}) => {
    return (
        <div className={props.className ? props.className : ''} tabIndex={0}>
            <p>
                There are two options to select a Peak Flow Q for the waterway design.
                <br />
                <ol type= 'a'>
                    <li>The recommended option is to select a previously completed Hydrology Analysis project for the waterway design. 
                        The storm frequency must be selected to populate the correct Peak Flow.</li>

                    <li>The application will populate the dropdown list with all Hydrology Analysis projects in the County, potentially 
                        including Projects other users have completed. The appropriate project must be selected.</li>

                    <li>The second option is to select User Defined to directly enter the Peak Flow Q for the waterway design. Hydrology 
                        calculations from another application can be used with this option.</li>
                </ol>
            </p>
            <p>
                The <strong>Initial Q Fraction (%)</strong> field is an optional field.
                <ol>
                    <li>It should be populated with the % of the design storm runoff expected to enter at the upstream end of the waterway. </li>

                    <li>It can be estimated by measuring the portion of the drainage area at the upstream end of the waterway in 
                        comparison to the entire drainage area. </li>

                    <li>If the Initial Q Fraction field is not populated it will be automatically populated with 100%. </li>
                </ol>
            </p>
        </div>
    ); 
}; 

export const AlignmentDetails = (props: {className?: string}) => {
    return (
        <div className={props.className ? props.className : ''} tabIndex={0}>
            <p>
                A previously created alignment (from the Alignment Tool) must be selected to generate the ground profile for the Waterway design. 
                Select the alignment created at the appropriate location for the Waterway design. <strong>The Seeding Buffer Width </strong> 
                 field is an optional field. This establishes an area around the Waterway for any needed additional seeding.
            </p>
        </div>
    ); 
}; 

export const DesignControlsDetails = (props: {className?: string}) => {
    return (
        <div className={props.className ? props.className : ''} tabIndex={0}>
            <p>
                <strong>The Design Controls</strong> establish how the designed waterway surface will interact with the original ground surface. 
                If the designed water level is above the ground surface, the application will assume fill is necessary. 
                <strong> The Fill Controls</strong> allow the user to establish how the fill and berm will be created. 
            </p>
            <p>
                <strong>The Side Fill Slope (%)</strong> and the <strong>Side Width Limit (ft)</strong> work together. 
                The application will use the Side Fill Slope (%) to project a fill surface to intersect the original 
                ground surface within the Side Width Limit (ft). If the intersection does not occur within the Side Width Limit, 
                a berm will be created using the <strong>Berm Top Width (ft)</strong> and <strong>Berm Back Slope (ft/ft)</strong> fields.
            </p>
            <img src={BermSlope} alt="A Diagram of a Berm"/>
            <br />
            <br /> 
            <a className="href-info-details105" href="/design/bermdiagram" target="_blank">
                <strong>Figure 1: Diagram of Berm</strong>
            </a>
            <p>
                <strong>The Channel Ends</strong> establish a transition from the waterway surface to the original ground surface 
                <strong> upstream (Start) and downstream (End)</strong> of the waterway. No transition zone is created if a zero 
                is entered in the field. The transition can be created by entering a specific distance in feet or by entering a slope 
                percentage.
            </p>
            <p>
                <strong>Freeboard (ft)</strong> is an optional field.
                <ol>
                    <li>It establishes additional depth within the designed waterway above the depth necessary for conveying the design 
                        storm runoff. </li>

                    <li>This can be used as a factor of safety to ensure flow remains in the waterway channel. </li>
                </ol>
            </p>
        </div>
    ); 
}; 